import { Player } from '@lottiefiles/react-lottie-player';
import bookLoader from '../../loader/loader.json'; // path to downloaded Lottie JSON

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-white">
      <Player
        autoplay
        loop
        src={bookLoader}
        style={{ height: '300px', width: '300px' }}
      />
    </div>
  );
};

export default Loader;
